var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:bitcoin",
    clipPath: "url(#clip0_521_156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.5481 45.3725C66.7381 64.6685 47.1881 76.3983 27.9197 71.5881C8.62315 66.7782 -3.10666 47.2291 1.70356 27.9609C6.51349 8.6649 26.0351 -3.06491 45.3316 1.74531C64.6001 6.52712 76.3583 26.0762 71.5481 45.3725Z",
    fill: "url(#paint0_linear_521_156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.7657 32.1808C54.4688 27.3996 50.8407 24.8121 45.8345 23.0965L47.4657 16.5996L43.5282 15.6152L41.9532 21.9433C40.9126 21.6902 39.8438 21.4371 38.7751 21.2121L40.3501 14.8558L36.4126 13.8715L34.8095 20.3402C33.9376 20.1433 33.0938 19.9465 32.2782 19.7496V19.7215L26.822 18.3715L25.7813 22.5902C25.7813 22.5902 28.7063 23.2652 28.6501 23.2933C30.2532 23.6871 30.5345 24.7558 30.4782 25.5996L28.622 32.9965C28.7345 33.0246 28.8751 33.0527 29.0438 33.1371C28.9032 33.109 28.7626 33.0808 28.622 33.0246L26.0345 43.3746C25.8376 43.8527 25.3313 44.584 24.2345 44.3027C24.2626 44.359 21.3657 43.5996 21.3657 43.5996L19.397 48.1277L24.5438 49.4215C25.5001 49.6746 26.4282 49.8996 27.3563 50.1527L25.7251 56.7058L29.6626 57.6902L31.2938 51.1933C32.3626 51.4746 33.4313 51.7558 34.4438 52.009L32.8407 58.4777L36.7782 59.4621L38.4095 52.909C45.1595 54.1746 50.222 53.6683 52.3313 47.5652C54.047 42.6715 52.247 39.8308 48.7032 37.9746C51.3188 37.384 53.2595 35.6683 53.7657 32.1808ZM44.7376 44.8371C43.5282 49.7308 35.2595 47.0871 32.5876 46.4121L34.7532 37.7215C37.4251 38.3965 46.0313 39.7183 44.7376 44.8371ZM45.9751 32.0965C44.8501 36.5683 37.9876 34.2902 35.7657 33.7277L37.7345 25.8527C39.9563 26.4152 47.1282 27.4558 45.9751 32.0965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_521_156",
    x1: 3598.68,
    y1: -1.06125,
    x2: 3598.68,
    y2: 7199.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.625 0.666748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.7774f122552697fdd39a20a70b9e259d.svg";
export { ForwardRef as ReactComponent };